import fetch from '../fetch';

export async function sendQRPayment(reservationId, amount, currency, description, bookingTypeData) {
	const path = bookingTypeData === 'request' ? '/requestApproveQRPayment' : '/generateQRPayment';
	const resp = await fetch(path, {
		method: 'post',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ reservationId, amount, currency, description }),
		credentials: 'include'
	});
	const res = await resp.json();
	const { status, errorMessage, data } = res

	return {
		data,
		status,
		errorMessage
	}
}

